export const CREATE_CQCPROVIDERS = "CREATE_CQCPROVIDERS";   
export const RETRIEVE_CQCPROVIDERS = "RETRIEVE_CQCPROVIDERS";
export const RETRIEVESINGLE_CQCPROVIDERS = "RETRIEVESINGLE_CQCPROVIDERS";
export const RETRIEVECHANGEDPROVIDERS_CQCPROVIDERS = "RETRIEVECHANGEDPROVIDERS_CQCPROVIDERS";
export const UPDATE_CQCPROVIDERS = "UPDATE_CQCPROVIDERS";   
export const DELETE_CQCPROVIDERS = "DELETE_CQCPROVIDERS"; 